import { Box } from "@mantine/core"
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router"
import React from "react"

import type { RouterContext } from "@/router"

const TanStackRouterDevtools = import.meta.env.DEV
  ? React.lazy(() =>
      import("@tanstack/react-router-devtools").then((res) => ({
        default: res.TanStackRouterDevtools,
      })),
    )
  : () => null

function RootComponent() {
  return (
    <Box style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Outlet />
      {import.meta.env.DEV && (
        <React.Suspense fallback={null}>
          <TanStackRouterDevtools />
        </React.Suspense>
      )}
    </Box>
  )
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})
